import { combineReducers } from 'redux'

import {
  createReducer,
  updateObject,
  createNamedReducer,
} from 'helpers/ReducerUtil'
import {
  UPDATE_CLOCK_VALUE,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  INITIALIZE_FILTER,
  PART_TYPE,
  DENSITY,
  ORG_SIZE,
  ORG_WIDTH,
  CHANNEL,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  INIT_CLOCK_VALUE,
  CONFIG,
  INIT_CONFIG,
  configString,
  IS_ADD_PART,
  INITIALIZE_CONFIG_FILTER,
} from './constants'

const updateClockValues = (values, action) => {
  const { config, value: clock } = action
  return values.map(value => {
    // update value only if it is from the specified config
    if (config.partType === value.partType && config.organizationSize === value.organizationSize &&
        config.organizationWidth === value.organizationWidth && config.density === value.density) {
      return updateObject(value, { clock: parseInt(clock) })
    }

    return value
  })
}

const togglePopup = (value) => {
  return !value
}

const toggleFilter = (values, action) => {
  const { index } = action
  return updateObject(values, {[index]: !(values[index])})
}

const refreshFilter = (values, action) => {
  let refreshedFilters = { ...values }

  for (let filterName in refreshedFilters) {
    if (refreshedFilters.hasOwnProperty(filterName)) {
      refreshedFilters[filterName] = false
    }
  }

  return refreshedFilters
}

const updateConfigSelection = (values, action) => {
  return action.newConfig
}

const updateConfigSource = (values, action) => {
  return action.newConfig
}

const initConfig = (values, action) => {
  return values.map(item => {
    const {
      partType,
      organizationSize,
      organizationWidth,
      density,
    } = item

    return {
      ...item,
      config: configString(partType, organizationSize, organizationWidth, density),
    }
  })
}

const addConfig = (value, action) => {
  return [...value, ...(action.configs)]
}

const deletePart = (value, action) => {
  const { deleteId } = action
  const newParts = [...value]

  value.some((part, index) => {
    if (part.id === deleteId) {
      newParts.splice(index, 1)
      return true
    }
  })

  return newParts
}

const updateCurConfig = (value, action) => {
  return action.curConfig
}

const isAddPart = (value, action) => action.value

const togglePopupReducer = createReducer(false, {
  [TOGGLE_POPUP]: togglePopup
})

const updateConfigSelectionReducer = createReducer([], {
  [UPDATE_CONFIG_SELECTION]: updateConfigSelection
})

const updateConfigSourceReducer = createReducer([], {
  [UPDATE_CONFIG_SOURCE]: updateConfigSource
})

const updateCurConfigReducer = createReducer({}, {
  [UPDATE_CURRENT_CONFIG]: updateCurConfig
})

const isAddPartReducer = createReducer(false, {
  [IS_ADD_PART]: isAddPart
})

const initConfigFilter = (state, action) => {
  const newStates = {}

  action.filters.forEach(filter => {
    newStates[filter] = false
  })

  return newStates
}

const initFilters = (state, action) => {
  const { filters, curConfig } = action
  const curConfigStr = String(curConfig)
  let newStates = {...state}

  // if a curConfig is provided (by clicking on add part), turn on filter in curConfig and
  // turn off all other filters
  if (curConfig) {
    filters.forEach(filterKey => {
      newStates[filterKey] = false
    })

    newStates[curConfigStr] = true
  } else if (Array.isArray(filters)) {
    // if filters is an array with multiple filter keys, iterate through them
    filters.forEach(filterKey => {
      if (curConfigStr === filterKey) {
        newStates[filterKey] = true
      } else {
        newStates[filterKey] = false
      }
    })
  } else if (typeof filters === 'string') {
    // if filters is a single filter key (a string), set it accordingly
    if (curConfigStr === filters) {
      newStates[filters] = true
    } else {
      newStates[filters] = false
    }
  }

  return newStates
}

const filterReducer = createReducer({}, {
  [INITIALIZE_CONFIG_FILTER]: initConfigFilter,
  [INITIALIZE_FILTER]: initFilters,
  [TOGGLE_FILTER]: toggleFilter,
  [REFRESH_FILTER]: refreshFilter,
})

export const memoryValueReducer = createReducer([], {
  [UPDATE_CLOCK_VALUE]: updateClockValues,
  [INIT_CONFIG]: initConfig,
  [ADD_CONFIG]: addConfig,
  [DELETE_PART]: deletePart,
})

export const createUiReducer = (uiPath) => {
  const namedUiReducer = (type) => {
    return createNamedReducer(type + uiPath, filterReducer)
  }

  return combineReducers({
    togglePopup: togglePopupReducer,
    configSelection: updateConfigSelectionReducer,
    configSource: updateConfigSourceReducer,
    curConfig: updateCurConfigReducer,
    isAddPart: isAddPartReducer,
    partTypeFilter: namedUiReducer(PART_TYPE),
    densityFilter: namedUiReducer(DENSITY),
    orgSizeFilter: namedUiReducer(ORG_SIZE),
    orgWidthFilter: namedUiReducer(ORG_WIDTH),
    channelFilter: namedUiReducer(CHANNEL),
    configFilter: namedUiReducer(CONFIG)
  })
}

